import { ArrowLeftIcon, PrinterIcon } from "@heroicons/react/24/outline";
import { ContentSection2Up, ContentSectionColumn } from "components/layout";
import { defaultLinkStyle } from "components/ui/link";
import { PrimaryButton } from "components/ui/primary-button";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { PrintViewSection, PrintViewSectionProps } from "./print-view-section";

export const PrintableForm = ({ sections }: { sections: PrintViewSectionProps[] }) => {
    const history = useHistory();

    const handleBack = React.useCallback(() => {
        history.goBack();
    }, [history]);

    const handlePrint = React.useCallback(() => {
        window.print();
    }, []);

    return (
        <div className="max-w-[816px] mx-auto">
            <div className="flex items-center justify-between pt-6 mb-2 print:hidden">
                <a
                    href="#"
                    onClick={handleBack}
                    className={`${defaultLinkStyle} flex items-center`}>
                    <ArrowLeftIcon className="w-4 h-4 mr-2" />
                    Back
                </a>
                <PrimaryButton onClick={handlePrint}>
                    <PrinterIcon className="w-4 h-4 mr-2" />
                    Print
                </PrimaryButton>
            </div>
            <ContentSection2Up>
                <ContentSectionColumn>
                    {sections.map(section => (
                        <div className="mt-8" key={section.title}>
                            <PrintViewSection
                                title={section.title}
                                fields={section.fields}>
                                {section.children}
                            </PrintViewSection>
                        </div>
                    ))}
                </ContentSectionColumn>
            </ContentSection2Up>
        </div>
    );
};
